module.exports = __webpack_public_path__ + "static/media/selectgame.480f0381.svg";